// extracted by mini-css-extract-plugin
export default {"loading":"ProtectedRoute_loading__sqoDH"};